import axios from 'axios'

//import { ID, Response } from '../../../../../_metronic/helpers'
//import { User, UsersQueryResponse } from './_models'

const API_URL = process.env.REACT_APP_THEME_API_URL
//const USER_URL = `${API_URL}/user`
const GET_USERS_URL = `${API_URL}/users/query`
const SUPPORT_URL = `${API_URL}/updatesupport`
const SUPPORT_GET = `${API_URL}/showsupport`

//const GET_COMPNAY = `${API_URL}/getCompany`
const GET_STRUCTURE = `${API_URL}/structure-list/`
const UPDATE_STUR = `${API_URL}/structure-edit`


const ADD_DESIGNATION = `${API_URL}/designation-add`
const DESIGNATION_UPDATE = `${API_URL}/designation-edit`
const DESIGNATION_LIST = `${API_URL}/designation-list`
const DESIGNATION_DETAIL = `${API_URL}/designation-detail`
//const DESIGNATION_ALL = `${API_URL}/designation-all`



const GET_OFFICES = `${API_URL}/office-list`
const UPDATE_OFFICES = `${API_URL}/office-edit`
const Add_OFFICES = `${API_URL}/office-add`
const OFFICE_DETAIL = `${API_URL}/office-detail`
const Add_OFFICES_STRUCT = `${API_URL}/getOfficeByStructureId`
const REVERSE_OFFICE_MAPPING = `${API_URL}/get-reverse-office-mapping`
const REPORTING_OFFICE_MAPPING_LIST = `${API_URL}/reporting-office-mapping-list`
const GET_REPORTING_MAPPING_BY_STRUCTURE = `${API_URL}/get-reporting-mapping-by-structure`
const GET_STRUCTURE_LIST = `${API_URL}/active-structure-list`
const CLUSTER_LIST = `${API_URL}/cluster-list`
const CLUSTER_DOWNLOAD = `${API_URL}/cluster-download`
const CLUSTER_PINCODE_DOWNLOAD = `${API_URL}/cluster-pincode-download`
const CLUSTER_ADD = `${API_URL}/cluster-add`
const CLUSTER_EDIT = `${API_URL}/cluster-edit`
const CLUSTER_DETAIL = `${API_URL}/cluster-detail`
const CLUSTER_MAPPING_LIST = `${API_URL}/cluster-mapping-list`
const CLUSTER_PINCODE_LIST = `${API_URL}/cluster-pincode-list`
const CLUSTER_UNMAPPED_PINCODE_LIST = `${API_URL}/cluster-unmapped-pincode-list`
const CLUSTER_UNMAPPED_PINCODE_DOWNLOAD = `${API_URL}/cluster-unmapped-pincode-download`
const CLUSTER_PINCODE_DELETE = `${API_URL}/cluster-pincode-delete`
const CLUSTER_PINCODE_STATUS = `${API_URL}/cluster-pincode-status`


const ADD_OFFER = `${API_URL}/offer-add`
const EDIT_OFFER = `${API_URL}/offer-edit`
const OFFER_LIST = `${API_URL}/offer-list`
const OFFER_DETAIL = `${API_URL}/offer-detail`
const OFFER_ALL = `${API_URL}/offer-all`

const ADD_PAGE = `${API_URL}/page-add`
const EDIT_PAGE = `${API_URL}/page-edit`
const PAGE_LIST = `${API_URL}/page-list`
const PAGE_DETAIL = `${API_URL}/page-detail`

const ADD_FAQ_CAT = `${API_URL}/faq-category-add`
const EDIT_FAQ_CAT = `${API_URL}/faq-category-edit`
const FAQ_LIST_CAT = `${API_URL}/faq-category-list`
const FAQ_DETAIL_CAT = `${API_URL}/faq-category-detail`
const FAQ_CAT_ALL = `${API_URL}/faq-category-all`


const ADD_FAQ = `${API_URL}/faq-add`
const EDIT_FAQ = `${API_URL}/faq-edit`
const FAQ_LIST = `${API_URL}/faq-list`
const FAQ_DETAIL = `${API_URL}/faq-detail`

const ADD_SETTINGS = `${API_URL}/company-settings-add`
const EDIT_SETTINGS = `${API_URL}/company-settings-edit`
const SETTINGS_LIST = `${API_URL}/company-settings-list`
const SETTINGS_DETAIL = `${API_URL}/company-settings-detail`

const ADD_USER_TYPE = `${API_URL}/user-type-add`
const EDIT_USER_TYPE = `${API_URL}/user-type-edit`
const USER_TYPE_LIST = `${API_URL}/user-type-list`
const USER_TYPE_DETAIL = `${API_URL}/user-type-detail`
const USER_TYPE_ALL = `${API_URL}/user-type-all`
const USER_TYPE_BY_PARENT = `${API_URL}/user-type-child-all`
const SKU_MAPPING_LIST = `${API_URL}/sku-mapping-list`

const ADD_REDEM = `${API_URL}/redemption-catalouge-add`
const EDIT_REDEM = `${API_URL}/redemption-catalouge-edit`
const REDEM_LIST = `${API_URL}/redemption-catalouge-list`
const REDEM_DETAIL = `${API_URL}/redemption-catalouge-detail`

const ADD_REDEMPTION = `${API_URL}/redemption-list-add`
const EDIT_REDEMPTION = `${API_URL}/redemption-list-edit`
const REDEMPTION_LIST = `${API_URL}/redemption-list`
const REDEMPTION_DETAIL = `${API_URL}/redemption-list-detail`
const REDEMPTION_ALL = `${API_URL}/redemption-list-all`

const ADD_REDEM_OFFER = `${API_URL}/redemption-catalouge-offer-add`
const EDIT_REDEM_OFFER = `${API_URL}/redemption-catalouge-offer-edit`
const REDEM_OFFER_LIST = `${API_URL}/redemption-catalouge-offer-list`
const REDEM_OFFER_DETAIL = `${API_URL}/redemption-catalouge-offer-detail`

const ADD_USER = `${API_URL}/user-add`
const EDIT_USER = `${API_URL}/user-edit`

const ADD_CO_USER = `${API_URL}/co-user-add`
const EDIT_CO_USER = `${API_URL}/co-user-edit`
const USER_LIST = `${API_URL}/user-list`
const USER_DETAIL_IIRPL = `${API_URL}/user-detail-IIRPL`

const USER_DETAIL = `${API_URL}/user-detail`
const USER_ADDRESS_EDIT = `${API_URL}/user-address-edit`
const CO_USER_MAPPING = `${API_URL}/co-user-structure`

const ADD_FORM = `${API_URL}/form-add`
const EDIT_FORM = `${API_URL}/form-edit`
const FORM_LIST = `${API_URL}/form-list`
const FORM_DETAIL = `${API_URL}/form-detail`
const QUES_TYPE = `${API_URL}/form-question-type`
const ADD_QUES = `${API_URL}/add-form-question`
const QUES_LIST = `${API_URL}/form-question-list`
const FORM_TYPE = `${API_URL}/form-type`
const USER_MAPPING = `${API_URL}/user-mapping`
const USER_REPORT_MAPPING = `${API_URL}/user-report-mapping`
const USER_REPORT_MAPPING_LIST = `${API_URL}/user-report-mapping-list`
const USER_REPORT_MAPPING_MAPPED = `${API_URL}/user-report-mapping-mapped`
const CO_USERS_FOR_REPORT_MAPPING = `${API_URL}/co-users-for-report-mapping`
const OFFICES_BY_CO_USER = `${API_URL}/offices-by-co-user`
const CO_USERS_BY_OFFICE = `${API_URL}/co-users-by-office`
const USER_REPORT_MAPPING_RETAILERS = `${API_URL}/user-report-mapping-retailers`
const USER_REPORT_MAPPING_ADD = `${API_URL}/user-report-mapping-add`
const USER_REPORT_MAPPING_DELETE = `${API_URL}/user-report-mapping-delete`
const STRUCTURES_WITH_OFFICES = `${API_URL}/structures-with-offices`
const STATE_DISTRICT = `${API_URL}/state-destrict`
const DISTRICT_PINCODES = `${API_URL}/district-pincodes`
const GET_PINCODE = `${API_URL}/pincode-detail`
const USER_TYPE_DOWNLOAD = `${API_URL}/download-endUser`
const PROJECT_COMPANY_ID = `${API_URL}/project-by-comid`
const GET_LANG = `${API_URL}/get-lang`
const USER_NOTE = `${API_URL}/user-notes`
const UPDATE_USER_NOTE = `${API_URL}/user_note_update`
const ADD_CHILD_QUESTION = `${API_URL}/add-child-question`
const ADD_CHILD_LIST = `${API_URL}/child-question-list`

const AUTO_ADD = `${API_URL}/autocall-add`
const UPDATE_AUTO = `${API_URL}/autocall-update`
const AUTO_DETAIL = `${API_URL}/autocall-detail`
const AUTOCALL_LIST = `${API_URL}/autocall-list`
const AUTOCALL_USER_LIST = `${API_URL}/autocall-user-list`
const USER_LEDGER_LIST = `${API_URL}/user-ledger-list`
const GET_PINCODE_USER_LIST = `${API_URL}/user-pincode-list`
const ADD_PINCODE_USER = `${API_URL}/add-user-pincode`
const DELETE_PINCODE_USER = `${API_URL}/user-pincode-delete`
const DOWNLOAD_PINCODE_USER = `${API_URL}/user-pincode-download`
const PROJECT_REPORT_SETTING = `${API_URL}/project-setting-report-list`
const ADD_PROJECT_REPORT = `${API_URL}/add-project-report`
const GET_CLASS = `${API_URL}/get-pro-user-cat`
const ADD_CLASS = `${API_URL}/add-pro-user-cat`
const P_USER_UPDATE = `${API_URL}/project-user-update`
const EDIT_USER_PERSON = `${API_URL}/update-key-person`
const DWONLOAD_REDEM_CATALUGUE = `${API_URL}/redemption-catalouge-downlod`
const DOWNLOAD_URL = `${API_URL}/download`
const DWONLOAD_COURIER_MAPPING = `${API_URL}/courier-mapping-download`
const DWONLOAD_COURIER = `${API_URL}/courier-download`
const DWONLOAD_PARTNER = `${API_URL}/partner-download`
const DWONLOAD_LOCATION = `${API_URL}/pickup-download`
const REDEM_PARTNER_LIST = `${API_URL}/redemption-partner-user-list`
const OFFICE_DOWNLOAD = `${API_URL}/office-download`

export const getQuestionsList = (query, form_id) => {
    query = query + '&form_id=' + form_id
    return axios.get(`${QUES_LIST}?${query}`).then((d) => d.data)
}
export const getQuestionCildList = (query, question_id) => {
    query = query + '&question_id=' + question_id
    return axios.get(`${ADD_CHILD_LIST}?${query}`).then((d) => d.data)
}
export const addQuestions = (query) => {
    return axios.post(ADD_QUES, query).then((d) => d.data)
}
export const addChildQuestions = (query) => {
    return axios.post(ADD_CHILD_QUESTION, query).then((d) => d.data)
}
export const getQuestionType = (query) => {
    return axios.get(`${QUES_TYPE}`).then((d) => d.data)
}

export const addForm = (query) => {
    return axios.post(ADD_FORM, query).then((d) => d.data)
}

export const editForm = (query) => {
    return axios.post(EDIT_FORM, query).then((d) => d.data)
}

export const getFormList = (query) => {

    return axios.get(`${FORM_LIST}?${query}`).then((d) => d.data)
}

export const getByFormId = (query) => {
    return axios.get(`${FORM_DETAIL}/${query}`).then((d) => d.data.data)
}
export const getFormType = (query) => {
    return axios.get(FORM_TYPE).then((d) => d.data.data)
}

export const addUser = (query) => {
    return axios.post(ADD_USER, query).then((d) => d.data)
}
export const addAddress = (query) => {
    return axios.post(USER_ADDRESS_EDIT, query).then((d) => d.data)
}
export const editUser = (query) => {
    return axios.post(EDIT_USER, query).then((d) => d.data)
}
export const editUserKeyPerson = (query) => {
    return axios.post(EDIT_USER_PERSON, query).then((d) => d.data)
}
export const projctUserUpdate = (query) => {
    return axios.post(P_USER_UPDATE, query).then((d) => d.data)
}
export const editCoUser = (query) => {
    return axios.post(EDIT_CO_USER, query).then((d) => d.data)
}
export const addCOUser = (query) => {
    return axios.post(ADD_CO_USER, query).then((d) => d.data)
}
export const getUserDetailIirpl = (query, type) => {
    query = query + '&type=' + type
    return axios.get(`${USER_DETAIL_IIRPL}/${query}`).then((d) => d.data.data)
}

export const getUserList = (query, type) => {
    query = query + '&type=' + type
    return axios.get(`${USER_LIST}?${query}`).then((d) => d.data)
}
export const getUserNotes = (query) => {

    return axios.get(`${USER_NOTE}?${query}`).then((d) => d.data)
}
export const updateUserNotes = (query) => {
    return axios.post(UPDATE_USER_NOTE, query).then((d) => d.data)
}
export const getByUserId = (id) => {
    return axios.get(`${USER_DETAIL}/${id}`).then((response) => response.data?.data)
}
export const coUserMapping = (query) => {
    return axios.post(CO_USER_MAPPING, query).then((d) => d.data)
}

export const getUserReportMapping = (query) => {
    return axios.get(`${USER_REPORT_MAPPING}?${query}`).then((d) => d.data)
}

export const getUserReportMappingList = (query) => {
    return axios.get(`${USER_REPORT_MAPPING_LIST}?${query}`).then((d) => d.data)
}

export const getUserReportMappingMapped = (query, userId, officeId) => {
    const params = new URLSearchParams(query)
    params.set('user_id', userId)
    if (officeId) {
        params.set('office_id', officeId)
    }
    return axios.get(`${USER_REPORT_MAPPING_MAPPED}?${params.toString()}`).then((d) => d.data)
}

export const getCoUsersForReportMapping = (search = '') => {
    const params = new URLSearchParams()
    if (search) {
        params.set('search', search)
    }
    const query = params.toString()
    return axios.get(`${CO_USERS_FOR_REPORT_MAPPING}${query ? `?${query}` : ''}`).then((d) => d.data)
}

export const getOfficesByCoUser = (userId, search = '') => {
    const params = new URLSearchParams({ user_id: userId })
    if (search) {
        params.set('search', search)
    }
    return axios.get(`${OFFICES_BY_CO_USER}?${params.toString()}`).then((d) => d.data)
}

export const getCoUsersByOffice = (officeId, search = '') => {
    const params = new URLSearchParams({ office_id: officeId })
    if (search) {
        params.set('search', search)
    }
    return axios.get(`${CO_USERS_BY_OFFICE}?${params.toString()}`).then((d) => d.data)
}

export const getUserReportMappingRetailers = (query, officeId, userId = null) => {
    const params = new URLSearchParams(query)
    params.set('office_id', officeId)
    if (userId) {
        params.set('user_id', userId)
    }
    return axios.get(`${USER_REPORT_MAPPING_RETAILERS}?${params.toString()}`).then((d) => d.data)
}

export const addUserReportMapping = (payload) => {
    return axios.post(USER_REPORT_MAPPING_ADD, payload).then((d) => d.data)
}

export const deleteUserReportMapping = (payload) => {
    return axios.post(USER_REPORT_MAPPING_DELETE, payload).then((d) => d.data)
}

export const getStructuresWithOffices = () => {
    return axios.get(STRUCTURES_WITH_OFFICES).then((d) => d.data)
}

const getOffice = (query) => {
    return axios.get(`${GET_OFFICES}?${query}`).then((d) => d.data)
}
const updateOffice = (query) => {
    return axios.post(`${UPDATE_OFFICES}`, query).then((d) => d.data)
}

const addOffice = (query) => {
    return axios.post(`${Add_OFFICES}`, query).then((d) => d.data)
}
export const addOfficeStruct = (query) => {
    return axios.post(`${Add_OFFICES_STRUCT}`, query).then((d) => d.data)
}
export const getReportingOfficeMappingList = () => {
    return axios.get(REPORTING_OFFICE_MAPPING_LIST).then((d) => d.data).then((d) => d.data)
}

export const getReportingMappingByStructure = (query) => {
    return axios.post(GET_REPORTING_MAPPING_BY_STRUCTURE, query).then((d) => d.data).then((d) => d.data)
}

export const reverseOfficeMapping = (query) => {
    return axios.post(`${REVERSE_OFFICE_MAPPING}`, query).then((d) => d.data)
}
export const officeDetailId = (id) => {
    return axios.get(`${OFFICE_DETAIL}/${id}`).then((d) => d.data).then((d) => d.data)
}

export const getCluster = (query) => {
    return axios.get(`${CLUSTER_LIST}?${query}`).then((d) => d.data)
}

export const downloadClusterList = (query = '') => {
    const url = query ? `${CLUSTER_DOWNLOAD}?${query}` : CLUSTER_DOWNLOAD
    return axios.get(url).then((d) => d.data)
}

export const downloadClusterPincodeList = (query = '') => {
    const url = query ? `${CLUSTER_PINCODE_DOWNLOAD}?${query}` : CLUSTER_PINCODE_DOWNLOAD
    return axios.get(url).then((d) => d.data)
}

export const addCluster = (query) => {
    return axios.post(CLUSTER_ADD, query).then((d) => d.data)
}

export const updateCluster = (query) => {
    return axios.post(CLUSTER_EDIT, query).then((d) => d.data)
}

export const clusterDetailId = (id) => {
    return axios.get(`${CLUSTER_DETAIL}/${id}`).then((d) => d.data).then((d) => d.data)
}

export const getClusterMappingList = () => {
    return axios.get(CLUSTER_MAPPING_LIST).then((d) => d.data).then((d) => d.data)
}

export const getClusterPincodeList = (query, clusterId) => {
    const clusterQuery = clusterId ? `${query}&cluster_id=${clusterId}` : query
    return axios.get(`${CLUSTER_PINCODE_LIST}?${clusterQuery}`).then((d) => d.data)
}

export const getUnmappedClusterPincodeList = (query) => {
    return axios.get(`${CLUSTER_UNMAPPED_PINCODE_LIST}?${query}`).then((d) => d.data)
}

export const downloadUnmappedClusterPincode = (query = '') => {
    const url = query ? `${CLUSTER_UNMAPPED_PINCODE_DOWNLOAD}?${query}` : CLUSTER_UNMAPPED_PINCODE_DOWNLOAD
    return axios.get(url).then((d) => d.data)
}

export const deleteClusterPincode = (query) => {
    return axios.post(CLUSTER_PINCODE_DELETE, query).then((d) => d.data)
}

export const updateClusterPincodeStatus = (query) => {
    return axios.post(CLUSTER_PINCODE_STATUS, query).then((d) => d.data)
}

export const getStructureList = (id) => {
    return axios.get(`${GET_STRUCTURE_LIST}`).then((d) => d.data.data)
}
const getStucture = (query) => {
    return axios.get(`${GET_STRUCTURE}${query}`).then((d) => d.data).then((d) => d.data)
}
const getStateDistrict = (query) => {
    return axios.get(`${STATE_DISTRICT}`).then((d) => d.data).then((d) => d.data)
}
const getPincodesByDistrictIds = (districtIds, params = {}) => {
    const ids = Array.isArray(districtIds) ? districtIds : [districtIds]
    return axios
        .post(DISTRICT_PINCODES, { district_ids: ids.filter(Boolean), ...params })
        .then((d) => d.data)
        .then((d) => d.data)
}
const updateStucture = (query) => {
    return axios.post(`${UPDATE_STUR}`, query).then((d) => d.data)
}
const getTeams = (query) => {
    return axios.get(`${GET_USERS_URL}?${query}`).then((d) => d.data)
}

// const getUserById = (id) => {
//     return axios
//         .get(`${USER_URL}/${id}`)
//         .then((response) => response.data)
//     // .then((response) => response.data)
// }
// const createUser = (user) => {
//     return axios
//         .put(USER_URL, user)
//         .then((response) => response.data)

// }
// const updateUser = (user) => {
//     return axios
//         .post(`${USER_URL}/${user.id}`, user)
//         .then((response) => response.data)
//     // .then((response) => response.data)
// }




const supportUpadte = (id, cat) => {
    return axios
        .post(`${SUPPORT_URL}${id}`, cat)
        .then((response) => response.data)

}
const getSupport = (id) => {
    return axios.get(`${SUPPORT_GET}${id}`).then((response) => response.data)
}


export const addRdemption = (query) => {
    return axios.post(ADD_REDEMPTION, query).then((d) => d.data)
}

export const editRdemption = (query) => {
    return axios.post(EDIT_REDEMPTION, query).then((d) => d.data)
}

export const listRdemption = (query) => {
    return axios.get(`${REDEMPTION_LIST}?${query}`).then((d) => d.data)
}

export const detailRdemption = (id) => {
    return axios.get(`${REDEMPTION_DETAIL}/${id}`).then((response) => response.data?.data)
}

export const allRdemption = (id) => {
    return axios.get(`${REDEMPTION_ALL}`).then((response) => response.data?.data)
}

const addOffer = (query) => {
    return axios.post(ADD_OFFER, query).then((d) => d.data)
}

const editOffer = (query) => {
    return axios.post(EDIT_OFFER, query).then((d) => d.data)
}

const listOffer = (query) => {
    return axios.get(`${OFFER_LIST}?${query}`).then((d) => d.data)
}

const detailOffer = (id) => {
    return axios.get(`${OFFER_DETAIL}/${id}`).then((response) => response.data?.data)
}

export const allOffer = (id) => {
    return axios.get(`${OFFER_ALL}`).then((response) => response.data?.data)
}
const addPage = (query) => {
    return axios.post(ADD_PAGE, query).then((d) => d.data)
}

const editPage = (query) => {
    return axios.post(EDIT_PAGE, query).then((d) => d.data)
}

const getPageList = (query) => {
    return axios.get(`${PAGE_LIST}?${query}`).then((d) => d.data)
}

const getByPageId = (id) => {
    return axios.get(`${PAGE_DETAIL}/${id}`).then((response) => response.data?.data)
}

export const addFaqCat = (query) => {
    return axios.post(ADD_FAQ_CAT, query).then((d) => d.data)
}

export const editFaqCat = (query) => {
    return axios.post(EDIT_FAQ_CAT, query).then((d) => d.data)
}

export const getFaqCatList = (query) => {
    return axios.get(`${FAQ_LIST_CAT}?${query}`).then((d) => d.data)
}

export const getByFaqCatId = (id) => {
    return axios.get(`${FAQ_DETAIL_CAT}/${id}`).then((response) => response.data?.data)
}

export const addFaq = (query) => {
    return axios.post(ADD_FAQ, query).then((d) => d.data)
}

export const editFaq = (query) => {
    return axios.post(EDIT_FAQ, query).then((d) => d.data)
}

export const getFaqList = (query) => {
    return axios.get(`${FAQ_LIST}?${query}`).then((d) => d.data)
}

export const getByFaqId = (id) => {
    return axios.get(`${FAQ_DETAIL}/${id}`).then((response) => response.data?.data)
}
export const getFaqCatAll = () => {
    return axios.get(`${FAQ_CAT_ALL}`).then((response) => response.data?.data)
}
export const addSettings = (query) => {
    return axios.post(ADD_SETTINGS, query).then((d) => d.data)
}

export const editSettings = (query) => {
    return axios.post(EDIT_SETTINGS, query).then((d) => d.data)
}

export const getSettingsList = (query) => {
    return axios.get(`${SETTINGS_LIST}?${query}`).then((d) => d.data)
}

export const getBySettingsId = (id) => {
    return axios.get(`${SETTINGS_DETAIL}/${id}`).then((response) => response.data?.data)
}

export const addUserType = (query) => {
    return axios.post(ADD_USER_TYPE, query).then((d) => d.data)
}

export const editUserType = (query) => {
    return axios.post(EDIT_USER_TYPE, query).then((d) => d.data)
}

export const getUserTypeList = (query) => {
    return axios.get(`${USER_TYPE_LIST}?${query}`).then((d) => d.data)
}

export const getByUserTypeId = (id) => {
    return axios.get(`${USER_TYPE_DETAIL}/${id}`).then((response) => response.data?.data)
}
export const getUserTypeAll = () => {
    return axios.get(`${USER_TYPE_ALL}`).then((response) => response.data?.data)
}
export const getUserTypeParent = () => {
    return axios.get(`${USER_TYPE_BY_PARENT}`).then((response) => response.data?.data)
}


export const getSkuMappingList = (query) => {
    return axios.get(`${SKU_MAPPING_LIST}?${query}`).then((response) => response.data)
}

export const addRedem = (query) => {

    return axios.post(ADD_REDEM, query).then((d) => d.data)
}

export const editRedem = (query) => {

    return axios.post(EDIT_REDEM, query).then((d) => d.data)
}

export const getRedemList = (query, redem_id) => {
    query = query + '&redem_id=' + redem_id
    return axios.get(`${REDEM_LIST}?${query}`).then((d) => d.data)
}

export const getByRedemId = (id) => {
    return axios.get(`${REDEM_DETAIL}/${id}`).then((response) => response.data?.data)
}


export const addRedemOffer = (query) => {

    return axios.post(ADD_REDEM_OFFER, query).then((d) => d.data)
}

export const editRedemOffer = (query) => {

    return axios.post(EDIT_REDEM_OFFER, query).then((d) => d.data)
}

export const getRedemOfferList = (query, redemption_catalogue_id) => {
    query = query + '&redemption_catalogue_id=' + redemption_catalogue_id
    return axios.get(`${REDEM_OFFER_LIST}?${query}`).then((d) => d.data)
}

export const getByRedemOfferId = (id) => {
    return axios.get(`${REDEM_OFFER_DETAIL}/${id}`).then((response) => response.data?.data)
}

export const addDesignation = (query) => {
    return axios.post(ADD_DESIGNATION, query).then((d) => d.data)
}
export const editDesignation = (query) => {
    return axios.post(DESIGNATION_UPDATE, query).then((d) => d.data)
}
export const getDesignationList = (query, offer_id) => {

    return axios.get(`${DESIGNATION_LIST}?${query}`).then((d) => d.data)
}
export const getByDesignationId = (id) => {
    return axios.get(`${DESIGNATION_DETAIL}/${id}`).then((response) => response.data?.data)
}
export const getUserMappingList = (query) => {
    return axios.post(USER_MAPPING, query).then((response) => response?.data?.data)
}
export const getPincodeDetail = (query) => {
    return axios.post(`${GET_PINCODE}`, query).then((d) => d.data)
}
export const downloadByUserType = (query) => {
    return axios.get(`${USER_TYPE_DOWNLOAD}/${query}`).then((response) => response.data)
}
export const getProjectAllByID = (query) => {
    return axios.get(`${PROJECT_COMPANY_ID}/${query}`).then((response) => response.data)
}
export const getLangUser = () => {
    return axios.get(GET_LANG).then((response) => response?.data)
}
export const getUserClass = (query) => {
    return axios.get(`${GET_CLASS}?${query}`).then((response) => response?.data)
}

export const addUserClass = (query) => {
    return axios.post(ADD_CLASS, query).then((response) => response?.data)
}

export const addAuto = (query) => {
    return axios.post(AUTO_ADD, query).then((d) => d.data)
}
export const getAuto = (query) => {
    return axios.get(`${AUTOCALL_LIST}?${query}`).then((response) => response.data)
}
export const editAuto = (query) => {
    return axios.post(UPDATE_AUTO, query).then((d) => d.data)
}
export const autoDetail = (query) => {
    return axios.get(`${AUTO_DETAIL}/${query}`).then((response) => response.data?.data)
}

export const getDistributorList = (query) => {
    return axios.get(AUTOCALL_USER_LIST).then((d) => d.data.data)
}
export const getUserLedegerList = (query) => {
    return axios.post(USER_LEDGER_LIST, query).then((d) => d.data)
}

export const getUserPincodeList = (query) => {
    return axios.get(`${GET_PINCODE_USER_LIST}?${query}`).then((d) => d.data)
}
export const addUserPincode = (query) => {
    return axios.post(ADD_PINCODE_USER, query).then((d) => d.data)
}
export const deletUserPincode = (query) => {
    return axios.post(DELETE_PINCODE_USER, query).then((d) => d.data)
}
export const downloadUserPincode = (query) => {
    return axios.post(DOWNLOAD_PINCODE_USER, query).then((d) => d.data)
}
export const getReportSetting = (query) => {
    return axios.get(PROJECT_REPORT_SETTING).then((d) => d.data)
}
export const addProjectReport = (query) => {
    return axios.post(ADD_PROJECT_REPORT, query).then((d) => d.data)
}

export const getCompanyStructureReportSetting = (structureId) =>
    axios.get(`${API_URL}/company-structure-report-setting?structure_id=${structureId}`).then(d => d.data)

export const getCompanyStructureReportList = (structureId) =>
    axios.get(`${API_URL}/company-structure-report-list?structure_id=${structureId}`).then(d => d.data)

export const addCompanyStructureReport = (payload) =>
    axios.post(`${API_URL}/company-structure-report-add`, payload).then(d => d.data)

export const downloadRedemCatalugue = (query) => {
    return axios.post(DWONLOAD_REDEM_CATALUGUE, query).then((d) => d.data)
}
export const downloadCourierMapping = (query) => {
    return axios.get(DWONLOAD_COURIER_MAPPING).then((d) => d.data)
}
export const downloadCourier = (query) => {
    return axios.get(DWONLOAD_COURIER).then((d) => d.data)
}
export const downloadPartner = (query) => {
    return axios.get(DWONLOAD_PARTNER).then((d) => d.data)
}
export const downloadPickupLocation = (query) => {
    return axios.get(DWONLOAD_LOCATION).then((d) => d.data)
}
export const downloadProductData = (query) => {
    return axios.get(`${DOWNLOAD_URL}/${query}`).then((d) => d.data)
}

export const redemPartnerUserList = (query) => {
    return axios.get(`${REDEM_PARTNER_LIST}?${query}`).then((d) => d.data)
}
export const downloadOfficeList = (query) => {
    return axios.get(OFFICE_DOWNLOAD).then((d) => d.data)
}
export const downloadReportByDate = (downloadApi, query) => {
    return axios.get(`${downloadApi}?${query}`).then((d) => d.data)
}
export {
    updateStucture,
    getStucture,
    getOffice,
    addOffice,
    updateOffice,
    getTeams,
    getStateDistrict,
    getPincodesByDistrictIds,
    supportUpadte,
    getSupport,
    addOffer,
    editOffer,
    listOffer,
    detailOffer,

    addPage, editPage, getPageList, getByPageId,
}